import { bostaHttp } from 'http.js';
import { downloadHeader } from 'utils/download';

export const fetchPickups = (payload) => {
  return bostaHttp.get(`/sllr/pickups/search`, payload);
};

export const fetchPickup = (id) => {
  return bostaHttp.get(`/sllr/pickups/${id}`);
};

export const createPickup = (payload) => {
  return bostaHttp.post(`/sllr/pickups`, payload);
};

export const createOrderPickup = (payload) => {
  return bostaHttp.post(`/sllr/deliveries/business/link-pickup`, payload);
};

export const editPickup = ({ id, payload }) => {
  return bostaHttp.put(`/sllr/pickups/${id}`, payload);
};

export const fetchPickupLocations = (payload) => {
  return bostaHttp.get(`/sllr/pickup-locations`, payload);
};

export const fetchPickupLocation = (id, payload) => {
  return bostaHttp.get(`/sllr/pickup-locations/${id}`, payload);
};

export const createPickupLocation = (payload) => {
  return bostaHttp.post(`/sllr/pickup-locations`, payload);
};

export const deletePickup = (id) => {
  return bostaHttp.delete(`/sllr/pickups/${id}`);
};

export const createContacts = ({ id, payload }) => {
  return bostaHttp.put(`/sllr/pickup-locations/${id}`, payload);
};

export const exportedPickupsDetailsFile = (id, payload) => {
  return bostaHttp.get(
    `/sllr/pickups/${id}/report/details`,
    payload,
    downloadHeader
  );
};

export const exportedPickupsFile = ({ payload }) => {
  return bostaHttp.get('/sllr/pickups/xlsx', payload, downloadHeader);
};

export const getDefaultContact = (payload) => {
  return bostaHttp.get('/businesses/get-default-contact', payload);
};

export const updateDefaultContact = (payload) => {
  return bostaHttp.put('/businesses/edit-default-contact', payload);
};

export const getHolidays = (payload) => {
  return bostaHttp.get('/sla/holidays', payload);
};

export const ratePickup = ({ pickupId, payload }) => {
  return bostaHttp.post(`/pickups/${pickupId}/rating`, payload);
};
